// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/hero-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section {
    text-align: center;
    padding: 60px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size: cover;
    color: #fff;
  }
  
  .hero-section h1 {
    font-size: 36px;
    font-weight: bold;
  }
  
  .hero-section p {
    font-size: 18px;
    margin: 20px 0;
  }
  
  .carousel-image {
    height: 300px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/HeroSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,2EAA+E;IAC/E,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;EACpB","sourcesContent":[".hero-section {\n    text-align: center;\n    padding: 60px;\n    background: url('../assets/images/hero-background.jpg') no-repeat center center;\n    background-size: cover;\n    color: #fff;\n  }\n  \n  .hero-section h1 {\n    font-size: 36px;\n    font-weight: bold;\n  }\n  \n  .hero-section p {\n    font-size: 18px;\n    margin: 20px 0;\n  }\n  \n  .carousel-image {\n    height: 300px;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
